/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, May 2020
 */

import React, { useContext } from 'react';
import { FlowBlockProfile as BlockModel } from '@staffino/model';
import { ProfileBlock as Component } from '@staffino/flow-controls';
import useObjects from '../use-objects-hook';
import useBridge from '../use-bridge-hook';
import FlowContext from '../flow-context';

type Props = {
  block: BlockModel;
};

const ProfileBlock = ({ block }: Props) => {
  const { stateManager } = useContext(FlowContext);
  const bridge = useBridge();
  const [lineage] = useObjects('target-lineage', { id: bridge.targetId });
  const [currentTarget] = useObjects('target', {
    id: stateManager.getTargetId(),
  });
  if (!lineage) {
    return null;
  }
  const targets = [...lineage.targets];
  if (targets.length === 1) {
    targets.unshift(
      currentTarget ?? {
        id: '30486842-1d90-43fb-93b3-8c567b5bf265',
        type: 'profile',
        name: 'Jane Doe',
        description: 'Employee of the Month',
        imageUrl:
          'https://cdn-static.staffino.com/images/default-avatars/img_staff.png',
      },
    );
  }
  return <Component block={block} targetLineage={targets} />;
};

export default ProfileBlock;
